export const disabledStyles = (props: { disabled?: boolean}) => `
  cursor: ${props.disabled ? 'default' : 'pointer'};
  opacity: ${props.disabled ? 0.4 : ''};
`;
